// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PatientInsuranceModel } from '../_models/patient-insurance.model';

export enum PatientInsuranceActionTypes {
  PatientInsuranceOnServerCreated = '[Patient insurance Dialog] Patient insurance On Server Created',
  PatientInsuranceCreated = '[Patient insurance Dialog] Patient insurance Created',
  PatientInsuranceOnServerUpdated = '[Edit Patient Insurance Dialog] Patient Insurance On Server Updated',
  PatientInsuranceUpdated = '[Edit Patient Insurance Dialog] Patient Insurance Updated',
  PatientInsuranceOnServerDeleted = '[PatientInsurance List Page] Patient Insurance On Server Deleted',
  PatientInsuranceDeleted = '[PatientInsurance List Page] Patient Insurance Deleted',
  PatientInsurancePageRequested = '[Patient Insurance List Page] Patient Insurance Page Requested',
  PatientInsurancePageLoaded = '[Patient Insurance API] Patient Insurance Page Loaded',
  PatientInsurancePageCancelled = '[Patient Insurance API] Patient Insurance Page Cancelled',
  PatientInsurancePageToggleLoading = '[Patient Insurance] Patient Insurance Page Toggle Loading',
  PatientInsuranceActionToggleLoading = '[Patient Insurance] Patient Insurance Action Toggle Loading',
  ThrowPatientInsuranceError = '[Patient Insurance] Throw Patient Insurance Error',
  ClearPatientInsuranceErrors = '[Patient Insurance] Clear Patient Insurance Errors',
  ClearPatientInsuranceState = '[Patient Insurance] Clear Patient Insurance State',
}

export class PatientInsuranceOnServerCreated implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceOnServerCreated;
  constructor(public payload: { patientInsurance: PatientInsuranceModel; patientId: number }) {}
}

export class PatientInsuranceCreated implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceCreated;

  constructor(public payload: { patientInsurance: PatientInsuranceModel }) {}
}

export class PatientInsuranceOnServerUpdated implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceOnServerUpdated;

  constructor(public payload: { patientInsurance: PatientInsuranceModel; patientId: number }) {}
}

export class PatientInsuranceUpdated implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceUpdated;

  constructor(
    public payload: {
      partialPatientInsurance: Update<PatientInsuranceModel>; // For State update
      patientInsurance: PatientInsuranceModel;
    },
  ) {}
}

export class PatientInsuranceOnServerDeleted implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceOnServerDeleted;

  constructor(public payload: { patientInsuranceId: number; patientId: number }) {}
}

export class PatientInsuranceDeleted implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceDeleted;

  constructor(public payload: { patientInsuranceId: number; patientId: number }) {}
}

export class PatientInsurancePageRequested implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsurancePageRequested;

  constructor(public payload: { page: QueryParamsModel; patientId: number }) {}
}

export class PatientInsurancePageLoaded implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsurancePageLoaded;

  constructor(
    public payload: {
      patientInsurance: PatientInsuranceModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class PatientInsurancePageCancelled implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsurancePageCancelled;
}

export class PatientInsurancePageToggleLoading implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsurancePageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class PatientInsuranceActionToggleLoading implements Action {
  readonly type = PatientInsuranceActionTypes.PatientInsuranceActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowPatientInsuranceError implements Action {
  readonly type = PatientInsuranceActionTypes.ThrowPatientInsuranceError;

  constructor(public payload: { error: any }) {}
}

export class ClearPatientInsuranceErrors implements Action {
  readonly type = PatientInsuranceActionTypes.ClearPatientInsuranceErrors;
}

export class ClearPatientInsuranceState implements Action {
  readonly type = PatientInsuranceActionTypes.ClearPatientInsuranceState;
}

export type PatientInsuranceActions =
  | PatientInsurancePageRequested
  | PatientInsurancePageLoaded
  | PatientInsuranceOnServerCreated
  | PatientInsuranceCreated
  | PatientInsuranceOnServerUpdated
  | PatientInsuranceUpdated
  | PatientInsuranceOnServerDeleted
  | PatientInsuranceDeleted
  | PatientInsurancePageCancelled
  | PatientInsurancePageToggleLoading
  | PatientInsuranceActionToggleLoading
  | ThrowPatientInsuranceError
  | ClearPatientInsuranceErrors
  | ClearPatientInsuranceState;
